/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";

const addOption = (setOptions, newValue) => {
    if (newValue) {
        console.log(newValue)
        setOptions(prevState => {
            let newOptions = prevState.options;
            let addNewOption = true;
            for (let optionIndex in newOptions) {
                if (newOptions[optionIndex].value === newValue) {
                    addNewOption = false;
                    break;
                }
            }
            if (addNewOption) {
                newOptions.push({ text: newValue, value: newValue, key: newValue });
            }
            return {
                ...prevState,
                "options": newOptions
            }
        });
    }
};
//TODO -- the changes improve the functional use of editing Citation citedArtifact Classifications
// BUT do not display pre-coded Classifier values and have a warning about duplicate keys
// and show duplicates of selected entries in the classifier choices (which is multiple)
const DropDownWithAdditions = ({ currentValue, labelText, options, optionsLookup, setOptions,
    setResourceElementState, setResourceElementStateForArray, index, elementName, subelementName,
    width, multiple, disabled }) => {

    if (width === undefined) {
        width = "100%";
    }

    const [selectedDropDownValueState, setSelectedDropDownValueState] = useState(null);
    const [startingSelectedDropDownValueState, setStartingSelectedDropDownValueState] = useState(null);

    useEffect(() => {
        if (currentValue === undefined) {
            if (multiple) {
                currentValue = [];
            } else {
                currentValue = "";
            }
        }
        let startingSelectedDropDownValue = "";
        let startingSelectedDropDownValues = [];
        if (Array.isArray(currentValue)) {
            if (currentValue.length) {
                startingSelectedDropDownValues = currentValue.map(concept => {
                    if (typeof concept === "object") {
                        return concept?.coding?.[0]?.code || concept?.text
                    } else {
                        return concept;
                    }
                });
            }
        } else if (typeof currentValue === "object") {
            startingSelectedDropDownValue = currentValue?.coding?.[0]?.code || currentValue?.text || currentValue.toString();
        } else if (typeof currentValue === "string") {
            startingSelectedDropDownValue = currentValue;
        } else {
            startingSelectedDropDownValue = currentValue.toString();
        }
        let startingValue = multiple ? startingSelectedDropDownValues : startingSelectedDropDownValue;
        setSelectedDropDownValueState(startingValue);
        setStartingSelectedDropDownValueState(startingValue);
        if (typeof startingValue === "string") {
            if (optionsLookup === undefined || optionsLookup[startingValue] === undefined) {
                setOptions(prevState => {
                    let newOptions;
                    let addNewOption = true;
                    for (let optionIndex in prevState.options) {
                        if (prevState.options[optionIndex].value === startingValue) {
                            addNewOption = false;
                            break;
                        }
                    }
                    if (addNewOption) {
                        newOptions = [{ text: startingValue, value: startingValue, key: startingValue }, ...prevState.options];
                    } else {
                        newOptions = prevState.options;
                    }
                    return {
                        ...prevState,
                        "options": newOptions,
                    }
                });
            }
        } else if (Array.isArray(startingValue)) {
            for (let theValue of startingValue) {
                if (optionsLookup === undefined || optionsLookup[theValue] === undefined) {
                    setOptions(prevState => {
                        let newOptions;
                        let addNewOption = true;
                        for (let optionIndex in prevState.options) {
                            if (prevState.options[optionIndex].value === theValue) {
                                addNewOption = false;
                                break;
                            }
                        }
                        if (addNewOption) {
                            newOptions = [{ text: theValue, value: theValue, key: theValue }, ...prevState.options];
                        } else {
                            newOptions = prevState.options;
                        }
                        return {
                            ...prevState,
                            "options": newOptions,
                        }
                    });
                }
            }
        }
    }, []);

    useEffect(() => {
        if (selectedDropDownValueState !== null &&
            JSON.stringify(selectedDropDownValueState) !== JSON.stringify(startingSelectedDropDownValueState)) {
            let newContent;
            if (multiple) {
                newContent = selectedDropDownValueState.map(code => {
                    if (optionsLookup[code]) {
                        return {
                            "coding": [{
                                "system": optionsLookup[code].system,
                                "code": code,
                                "display": optionsLookup[code].display
                            }]
                        };
                    } else {
                        return { "text": code };
                    }
                });
            } else {
                if (optionsLookup[selectedDropDownValueState]) {
                    newContent = {
                        "coding": [{
                            "system": optionsLookup[selectedDropDownValueState].system,
                            "code": selectedDropDownValueState,
                            "display": optionsLookup[selectedDropDownValueState].display
                        }]
                    };
                } else {
                    newContent = { "text": selectedDropDownValueState };
                }
            }
            if (subelementName) {
                if (setResourceElementStateForArray) {
                    setResourceElementStateForArray(prevState => {
                        let newArray = JSON.parse(JSON.stringify(prevState[elementName]));
                        newArray[index][subelementName] = newContent;
                        return { ...prevState, [elementName]: newArray };
                    });
                } else if (setResourceElementState) {
                    setResourceElementState(prevState => {
                        return { ...prevState, [elementName]: { ...prevState, [subelementName]: newContent } };
                    });
                }
            } else {
                if (setResourceElementStateForArray) {
                    setResourceElementStateForArray(prevState => {
                        let newArray = JSON.parse(JSON.stringify(prevState[elementName]));
                        newArray[index] = newContent;
                        return { ...prevState, [elementName]: newArray };
                    });
                } else if (setResourceElementState) {
                    setResourceElementState(prevState => {
                        return { ...prevState, [elementName]: newContent };
                    });
                }
            }
        }
    }, [selectedDropDownValueState]);

    if (selectedDropDownValueState !== null) {
        return <Dropdown placeholder={labelText} closeOnChange search selection
            selectOnBlur={false} multiple={multiple} allowAdditions clearable
            style={{ width: width }} fluid
            disabled={disabled}
            options={options}
            value={selectedDropDownValueState}
            onAddItem={(e, data) => {
                if (optionsLookup === undefined || optionsLookup[data.value] === undefined) {
                    addOption(setOptions, data.value);
                }
            }}
            onChange={(e, data) => {
                setSelectedDropDownValueState(data.value);
            }}
        />
    }
};

export default DropDownWithAdditions;